import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/** Redirect legacy benchmarks route into Revenue & Profit. */
const BenchmarkPage: React.FC = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate('/owner-intelligence/profit#benchmarks', { replace: true });
  }, [navigate]);
  return null;
};

export default BenchmarkPage;
